export default Object.freeze({
  Mask: 1,
  Pseudonymize: 2,
  TokenizeReversible: 3,
  Remove: 4,
  Keep: 5,
});
